import React, {createContext, useMemo, useState} from "react";

export const AppContext = createContext();

export const AppProvider = ({children}) => {
  const [selectedDate, setSelectedDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0];
  });

  const contextValue = useMemo(() => {
    return {
      selectedDate,
      setSelectedDate,
    };
  }, [selectedDate]);

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};

export default AppProvider;
